/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.10.17",
    versionName: "0.2.0-nightly.2025.10.17",
    versionChannel: "nightly",
    buildDate: "2025-10-17T00:09:22.749Z",
    commitHash: "3a64829530b28f84251c9ad4b2f6331e2716d6bc",
};
